import axios from 'axios'
import { 
    dbFirestore,
    enviometodosRef,
    usuarioRef,
    rubrosRef,
    pedidosRef,
    pedidosContRef,
    categoriasRef,
    productosRef,
    authRef,
    refProdsImgs,
    refCustomImgs 
} from "../config/firebase";
import moment from "moment";

export const GET_PRODUCTOS_ADMIN = "GET_PRODUCTOS_ADMIN";
export const GET_PRODUCTO_ADMIN = "GET_PRODUCTO_ADMIN";
export const GET_PEDIDOS_ADMIN = "GET_PEDIDOS_ADMIN";
export const GET_PEDIDO_ADMIN = "GET_PEDIDO_ADMIN";
export const GET_RUBROSCATS_ADMIN = "GET_RUBROSCATS_ADMIN";
export const UPDATE_PRECIO = "UPDATE_PRECIO";

export const RUBRO_GUARDA = "RUBRO_GUARDA";
export const CATEGORIA_GUARDA = "CATEGORIA_GUARDA";
export const PRODUCTO_GUARDA = "PRODUCTO_GUARDA";
export const OPCION_GUARDA = "OPCION_GUARDA";
export const CUSTOMDATA_GUARDA = "CUSTOMDATA_GUARDA";
export const GRUPOS_GUARDA = "GRUPOS_GUARDA";

export const IMG_CATEGORIA_SET = "IMG_CATEGORIA_SET";
export const IMG_RUBRO_SET = "IMG_RUBRO_SET";

export const CREA_PRECIO = "CREA_PRECIO";
export const BORRA_RUBRO = "BORRA_RUBRO";
export const BORRA_CATEGORIA = "BORRA_CATEGORIA";
export const BORRA_PRODUCTO = "BORRA_PRODUCTO";
export const BORRA_OPCION = "BORRA_OPCION";
export const BORRA_GRUPO = "BORRA_GRUPO";
export const BORRA_METODO = "BORRA_METODO";
export const BORRA_PRECIO = "BORRA_PRECIO";
export const UPLOAD_IMG_OPCION = "UPLOAD_IMG_OPCION";
export const UPLOAD_IMG_CUSTOM = "UPLOAD_IMG_CUSTOM";
export const UPLOAD_IMG_CATEGORIA = "UPLOAD_IMG_CATEGORIA";
export const UPLOAD_IMG_PRODUCTO = "UPLOAD_IMG_PRODUCTO";
export const PEDIDO_UPDATE_STAT = "PEDIDO_UPDATE_STAT";

export const SEND_USER_MSJ = "SEND_USER_MSJ";

export const guardaProducto = async (id_producto, datos) => {
    var act
    try {
        //console.log(id_producto)
        //console.log(datos)
        if (id_producto){
            act="up"
            //SI NO ES NULL UPDATEA
            const productoUp = await productosRef.doc(id_producto).update(datos)
            datos.id=id_producto
            //console.log(productoUp)
        }else{
            act = "add";
            const productoAdd = await productosRef.add(datos)
            datos.id = productoAdd.id;
            datos.precios=[]
            datos.opciones = []
            //console.log(datos);
        }

        return {
            type: PRODUCTO_GUARDA,
            id_producto: id_producto,
            datos: datos,
            act
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const guardaCustomData = async (id_producto, datos) => {
    try {
        //console.log(id_producto)
        //console.log(datos)
        const customsUp = await productosRef.doc(id_producto).update({custom_data:datos})
        //console.log(customsUp);
        return {
            type: CUSTOMDATA_GUARDA,
            id_producto: id_producto,
            datos: datos
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}


export const guardaPrecio = async (id_producto, id_precio, precio) => {
    try {
        var precioNew = parseFloat(precio)
        const precioUp = await productosRef.doc(id_producto).collection("precios").doc(id_precio).update({ precio: precioNew })
        //console.log(precioUp);
        return {
            type: UPDATE_PRECIO,
            id: id_precio,
            precio: parseFloat(precio)
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}


export const guardaOpcion = async (id_producto, id_opcion, datos) => {
         try {
           var act;
           //console.log(id_producto);
           //console.log(id_opcion);
           //console.log(datos);
           if (id_opcion) {
                act = "up";
                //SI NO ES NULL UPDATEA
                const opcionUp = await productosRef.doc(id_producto).collection("opciones").doc(id_opcion).update(datos)
                datos.id = id_opcion;
                //console.log(opcionUp)
           } else {
                act = "add";
                const opcionAdd = await productosRef.doc(id_producto).collection("opciones").add(datos)
                //console.log(opcionAdd)
                id_opcion = opcionAdd.id;
                datos.id=opcionAdd.id;
           }
            return { 
                type: OPCION_GUARDA,
                id_producto: id_producto, 
                id_opcion: id_opcion, 
                datos: datos,
                act 
            };
         } catch (err) {
             console.log(err)
           return { 
                type: SEND_USER_MSJ, 
                resp: 0, 
                msj: err, 
                tipo: 3 
            };
         }
       };

export const guardaRubro = async (id, datos) => {
    try{
        //console.log(id)
        //console.log(datos)
        var act
        if (id) {
            act="up"
            //VER DE UPDATEAR CATEGORIAS AL MODIFICAR EL RUBRO
            const rubroUp = await rubrosRef.doc(id).update(datos)
            datos.id = id
        } else {
            act="add"
            const rubroAdd = await  rubrosRef.add(datos)
            datos.id = rubroAdd.id;
            //console.log(datos);
        }
        return {
            type: RUBRO_GUARDA,
            id: id,
            datos:datos,
            act
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const guardaCat = async (id, datos) => {
    try{
        var act
        //console.log(id)
        //console.log(datos)
        if (id) {
            act="up"
            const categoriaUp = await categoriasRef.doc(id).update(datos)
            /*
            HACER QUE HAGA UN UPDATE DE TODOS LOS PRODUCTOS QUE TIENEN ESTA CATEGORIA
            const productosCatUp = await productosRef.where('categoria.id',"=",id).get()
            */
            //console.log(datos);
        } else {
            act="add"
            const categoriaAdd = await  categoriasRef.add(datos)
            datos.id = categoriaAdd.id;
            //console.log(datos);
        }
        return {
            type: CATEGORIA_GUARDA,
            id: id,
            datos:datos,
            act
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const guardaGrupo = async (id_producto, datos) => {
    try {
        const gruposUp = await productosRef.doc(id_producto).update({grupos:datos})    
        return {
            type: GRUPOS_GUARDA,
            id_producto: id_producto,
            datos: datos,
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}


export const creaPrecio = async (id_producto, datos) => {
    try {
        const precioAdd = await productosRef.doc(id_producto).collection("precios").add(datos)
        datos.id = precioAdd.id
        return {
            type: CREA_PRECIO,
            datos: datos,
            id_producto:id_producto
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}


export const borraRubro = async (id_rubro) => {
    try {
        //console.log(id_rubro)
        const rubroDel = await rubrosRef.doc(id_rubro).delete()
        //console.log(rubroDel);
        return {
            type: BORRA_RUBRO,
            id_rubro: id_rubro
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const borraCategoria = async (id_categoria) => {
    try {
        //console.log(id_categoria)
        const catDel = await categoriasRef.doc(id_categoria).delete()
        return {
            type: BORRA_CATEGORIA,
            id_categoria: id_categoria
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const borraMetodo = async (id) => {
    try {
        const catDel = await enviometodosRef.doc(id).delete();
        return {
            type: BORRA_METODO,
            id: id
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const borraProducto = async (id_producto,img_producto,imagenes,customs) => {
    
    if(img_producto){
        try {
            await refProdsImgs.child(img_producto).delete();
        } catch (err) {
            console.log(err);
        }
    }

    imagenes.forEach(async img => {
      try {
        //console.log(img);
        await refProdsImgs.child(img + ".png").delete();
      } catch (err) {
        console.log(err);
      }
    });

    customs.forEach(async cust => {
        try {
            //console.log(cust);
            await refCustomImgs.child(cust + ".png").delete();
        } catch (err) {
            console.log(err)
        }
    })

    try {
        //console.log(id_producto)
        await productosRef.doc(id_producto).delete()
        return {
            type: BORRA_PRODUCTO,
            id_producto: id_producto
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}
export const borraOpcion = async (id_producto, id_opcion,img) => {
    try {
        //console.log(id_producto)
        //console.log(id_opcion)
        //console.log(img)
        const opcionDel = await productosRef.doc(id_producto).collection("opciones").doc(id_opcion).delete()
        //HACER QUE BORRE LA IMAGEN img
        return {
            type: BORRA_OPCION,
            id_opcion: id_opcion,
            id_producto: id_producto
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const borraPrecio = async (id_producto, id_precio) => {
    try {
        //console.log(id_producto)
        //console.log(id_precio)
        const precioDel = await productosRef.doc(id_producto).collection("precios").doc(id_precio).delete()
        return {
            type: BORRA_PRECIO,
            id_precio: id_precio,
            id_producto: id_producto
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const borraGrupo = async (id_producto, grupos) => {
    try {
        //console.log(id_producto)
        //console.log(grupos);
        const precioDel = await productosRef.doc(id_producto).update({grupos:grupos})
        return {
            type: BORRA_GRUPO,
            grupos: grupos,
            id_producto: id_producto
        }
    } catch (err) {
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}


export const uploadImgOpcion= async (id_producto,id_grupo,id_opcion, file,imgActual) => {
    try {
        if (imgActual != null) {
            const delAntProd = await refProdsImgs.child(  imgActual +".png").delete();
        }
    } catch (err) {
        console.log(err)
    }

    try {
        //console.log(id_producto)
        //console.log(id_opcion)
        //console.log(file)
        const name = moment().format("DDMMYYYYHHmmss") + "_" + file[0].name
        const namedb = moment().format("DDMMYYYYHHmmss") + "_" + file[0].name.split(".")[0];
        const metadata = { contentType: file[0].type };
        const task = await refProdsImgs.child(name).put(file[0], metadata);
        const opcionImg = await productosRef.doc(id_producto).collection("opciones").doc(id_opcion).update({ img: namedb})
        //console.log(opcionImg);
        return {
            type: UPLOAD_IMG_OPCION,
            id_opcion: id_opcion,
            id_grupo: id_grupo,
            id_producto: id_producto,
            img:namedb
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const uploadImgCustom= async (id_producto,id_opcion, file) => {
    try {
        const delAnt = await refCustomImgs.child(id_opcion +".png").delete();
    } catch (err) {
      console.log(err);
    }

    try {
        //console.log(id_producto)
        //console.log(id_opcion)
        //console.log(file)
        //OJO TIENEN QUE SER .png
        const name = id_opcion + "." + file[0].name.split(".")[1]
        const metadata = { contentType: file[0].type };
        const task = await refCustomImgs.child(name).put(file[0], metadata);
        return {
            type: UPLOAD_IMG_CUSTOM,
            id_opcion: id_opcion,
            id_producto: id_producto,
            img: name
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const uploadImgCategoria= async (id_categoria,imgActual, file) => {
    try {
        if (imgActual != null){
            const delAntProd = await refProdsImgs.child(imgActual).delete();
        }
    } catch (err) {
        console.log(err)
    }

    try {
        const name = moment().format('DDMMYYYYHHmmss') +"_"+file[0].name
        const metadata = { contentType: file[0].type };
        const task = await refProdsImgs.child(name).put(file[0], metadata);
        const opcionImg = await categoriasRef.doc(id_categoria).update({img:name})
        return {
            type: UPLOAD_IMG_CATEGORIA,
            id_categoria: id_categoria,
            img:name
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const uploadImgProducto = async (id_producto, imgActual, file) => {
    try {
        if (imgActual != null) {
            const delAntProdImg = await refProdsImgs.child(imgActual).delete();
        }
    } catch (err) {
        console.log(err)
    }

    try {
        const name = moment().format('DDMMYYYYHHmmss') + "_" + file[0].name
        const metadata = { contentType: file[0].type };
        const task = await refProdsImgs.child(name).put(file[0], metadata);
        const opcionImg = await productosRef.doc(id_producto).update({ img: name })
        return {
            type: UPLOAD_IMG_PRODUCTO,
            id_producto: id_producto,
            img: name
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            resp: 0,
            msj: err,
            tipo: 3
        }
    }
}

export const pedidoUpdate = async (id_pedido, stat) => {
    try {
        /*console.log(id_pedido)
        console.log(stat)*/
        const pedidoStatUp = await pedidosRef.doc(id_pedido).update({ stat: stat })
        //console.log(pedidoStatUp);
        return {
            type: PEDIDO_UPDATE_STAT,
            id_pedido,
            stat
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            msj: err.message,
            tipo: 3
        }
    }
}

export const getPedidosAdmin = async (pag) => {
    try {
        const pedidos = await pedidosRef.orderBy("fechaunix", "desc").get()
        return {
            type: GET_PEDIDOS_ADMIN,
            pedidos
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            msj: err.message,
            tipo: 3
        }
    }
}

export const getPedidoAdmin = async (id_pedido) => {
    try {
        const pedidoCont = await pedidosContRef.where("id_pedido", '==', id_pedido).get()
        return {
            type: GET_PEDIDO_ADMIN,
            pedidoCont,
            id_pedido
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            msj: err.message,
            tipo: 3
        }
    }
}

export const getProductosAdmin = async (categoria) => {
    try {
        const productos = await productosRef.orderBy("rubro.id").orderBy("categoria.id").orderBy("orden").orderBy("nombre").get()
        return {
            type: GET_PRODUCTOS_ADMIN,
            productos
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            msj: err.message,
            tipo: 3
        }
    }
}

export const getProductoAdmin = async (producto) => {
    try {
        const opciones = await productosRef.doc(producto).collection("opciones").orderBy("opcion.orden").orderBy("opcion.id").orderBy("orden").get()
        const precios = await productosRef.doc(producto).collection("precios").orderBy("cantidad").get()
        return {
            type: GET_PRODUCTO_ADMIN,
            opciones,
            precios,
            meta: producto
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            msj: err.message,
            tipo: 3
        }
    }
}

export const getRubroCats = async () => {
    try {
        const rubros = await rubrosRef
          .orderBy("orden")
          .get();
        
        const cats = await categoriasRef
          .orderBy("rubro.orden")
          .orderBy("orden")
          .get();
        return {
            type: GET_RUBROSCATS_ADMIN,
            categorias:cats,
            rubros: rubros
        }
    } catch (err) {
        console.log(err)
        return {
            type: SEND_USER_MSJ,
            msj: err.message,
            tipo: 3
        }
    }
}




// WEBPACK FOOTER //
// ./src/actions/admin.js